import type { ReactNode } from 'react';

export const symbol_unfold_less_double: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M481-127 375-22q-9 8-21 8.5T333-22q-9-9-9-21t9-21l126-127q5-5 10-7t11-2q6 0 11 2t10 7L629-63q9 9 9 21t-9 21q-9 9-21 9t-21-9L481-127Zm0-200L375-222q-9 8-21 8.5t-21-8.5q-9-9-9-21t9-21l126-127q5-5 10-7t11-2q6 0 11 2t10 7l128 128q9 9 9 21t-9 21q-9 9-21 9t-21-9L481-327Zm-1-307 106-105q9-9 21.5-9t21.5 9q9 9 9 21.5t-9 21.5L502-569q-5 5-10 7t-11 2q-6 0-11-2t-10-7L332-697q-9-9-8.5-21t9.5-21q9-9 21-9t21 9l105 105Zm0-200 106-105q9-9 21.5-9t21.5 9q9 9 9 21.5t-9 21.5L502-769q-5 5-10 7t-11 2q-6 0-11-2t-10-7L332-897q-9-9-8.5-21t9.5-21q9-9 21-9t21 9l105 105Z"
		/>
	</svg>
);
